import { Outlet, useParams } from '@tanstack/react-router';
import { ActiveBoardProvider } from '../stores/ActiveBoardContext';
import { boardsStore } from '../../stores/boardsStore';

export function BoardLayout() {
  const { boardId } = useParams({ strict: false }) as { boardId: string };

  // Ensure active board is set in boardsStore
  const currentActive = boardsStore.getSnapshot().context.activeBoardId;
  if (currentActive !== boardId) {
    boardsStore.send({ type: 'board.setActive', boardId });
  }

  return (
    <ActiveBoardProvider boardId={boardId}>
      <Outlet />
    </ActiveBoardProvider>
  );
}
